import {
  SiShopify, SiMeta, SiGoogleads, SiGoogle, SiBrave, SiNotion, SiFigma, SiGithub, SiHubspot, SiAsana, SiPinterest, SiTiktok,
  SiGoogleanalytics, SiTrustpilot, SiVercel, SiLinear, SiAirtable, SiIntercom, SiStripe, SiSupabase, SiCloudflare, SiWebflow,
  SiMixpanel, SiDropbox, SiClickup, SiAtlassian, SiGooglesheets, SiGooglesearchconsole, SiGmail, SiInstagram, SiFacebook,
  SiMailchimp, SiZapier, SiWordpress, SiGoogledrive,
} from "react-icons/si";
import { FaSlack, FaAmazon } from "react-icons/fa";
import { BsMicrosoftTeams } from "react-icons/bs";

import { Mail, Store, Send, MessageSquareText, FlaskConical, Briefcase, Repeat, Wand2 } from "lucide-react";

const MAP = {
  shopify: { Icon: SiShopify, color: "#96BF48" },
  klaviyo: { Icon: Mail, color: "#111827" },
  omnisend: { Icon: Send, color: "#6A5CF5" },
  attentive: { Icon: MessageSquareText, color: "#CA8A04" },
  meta_ads: { Icon: SiMeta, color: "#0081FB" },
  google_ads: { Icon: SiGoogleads, color: "#4285F4" },
  google_merchant: { Icon: Store, color: "#34A853" },
  google_workspace: { Icon: SiGoogle, color: "#EA4335" },
  amazon: { Icon: FaAmazon, color: "#FF9900" },
  amazon_seller: { Icon: FaAmazon, color: "#FF9900" },
  intelligems: { Icon: FlaskConical, color: "#38BDF8" },
  slack: { Icon: FaSlack, color: "#E01E5A" },
  microsoft_teams: { Icon: BsMicrosoftTeams, color: "#6264A7" },
  honcho: { Icon: Briefcase, color: "#F97316" },
  loop_subscriptions: { Icon: Repeat, color: "#7C3AED" },
  higgsfield: { Icon: Wand2, color: "#EC4899" },
  brave_search: { Icon: SiBrave, color: "#FB542B" },
  // The apps the agent signs into itself (native MCP) or links through Pipedream.
  notion: { Icon: SiNotion, color: "#000000" },
  figma: { Icon: SiFigma, color: "#F24E1E" },
  github: { Icon: SiGithub, color: "#181717" },
  hubspot: { Icon: SiHubspot, color: "#FF7A59" },
  asana: { Icon: SiAsana, color: "#F06A6A" },
  pinterest: { Icon: SiPinterest, color: "#BD081C" },
  tiktok: { Icon: SiTiktok, color: "#000000" },
  // TikTok Ads links through Pipedream's TikTok Ads Manager app and carries the TikTok mark.
  tiktok_ads: { Icon: SiTiktok, color: "#000000" },
  google_analytics: { Icon: SiGoogleanalytics, color: "#E37400" },
  google_search_console: { Icon: SiGooglesearchconsole, color: "#458CF5" },
  google_sheets: { Icon: SiGooglesheets, color: "#34A853" },
  google_drive: { Icon: SiGoogledrive, color: "#4285F4" },
  gmail: { Icon: SiGmail, color: "#EA4335" },
  instagram: { Icon: SiInstagram, color: "#E4405F" },
  // The Pipedream apps for Facebook Pages and Instagram business accounts carry the same marks as the legacy ids.
  instagram_business: { Icon: SiInstagram, color: "#E4405F" },
  facebook: { Icon: SiFacebook, color: "#0866FF" },
  facebook_pages: { Icon: SiFacebook, color: "#0866FF" },
  trustpilot: { Icon: SiTrustpilot, color: "#00B67A" },
  vercel: { Icon: SiVercel, color: "#000000" },
  linear: { Icon: SiLinear, color: "#5E6AD2" },
  airtable: { Icon: SiAirtable, color: "#18BFFF" },
  intercom: { Icon: SiIntercom, color: "#6AFDEF" },
  stripe: { Icon: SiStripe, color: "#635BFF" },
  supabase: { Icon: SiSupabase, color: "#3FCF8E" },
  cloudflare: { Icon: SiCloudflare, color: "#F38020" },
  webflow: { Icon: SiWebflow, color: "#146EF5" },
  mixpanel: { Icon: SiMixpanel, color: "#7856FF" },
  dropbox: { Icon: SiDropbox, color: "#0061FF" },
  clickup: { Icon: SiClickup, color: "#7B68EE" },
  atlassian: { Icon: SiAtlassian, color: "#0052CC" },
  mailchimp: { Icon: SiMailchimp, color: "#FFE01B" },
  zapier: { Icon: SiZapier, color: "#FF4F00" },
  wordpress: { Icon: SiWordpress, color: "#21759B" },
};

const NAME_TO_ID = {
  Shopify: "shopify",
  Klaviyo: "klaviyo",
  Omnisend: "omnisend",
  Attentive: "attentive",
  "Meta Ads": "meta_ads",
  "Google Ads": "google_ads",
  "Google Merchant Center": "google_merchant",
  "Google Workspace": "google_workspace",
  Amazon: "amazon",
  "Amazon Seller Central": "amazon_seller",
  Intelligems: "intelligems",
  Slack: "slack",
  "Microsoft Teams": "microsoft_teams",
  Honcho: "honcho",
  "Loop Subscriptions": "loop_subscriptions",
  Higgsfield: "higgsfield",
  "Brave Search": "brave_search",
  Notion: "notion",
  Figma: "figma",
  GitHub: "github",
  HubSpot: "hubspot",
  Asana: "asana",
  Pinterest: "pinterest",
  "TikTok Ads": "tiktok_ads",
  "Google Analytics": "google_analytics",
  "Google Search Console": "google_search_console",
  "Google Sheets": "google_sheets",
  "Google Drive": "google_drive",
  Gmail: "gmail",
  Instagram: "instagram",
  Facebook: "facebook",
  "Facebook Pages": "facebook_pages",
  Trustpilot: "trustpilot",
  Vercel: "vercel",
  Linear: "linear",
  Airtable: "airtable",
  Intercom: "intercom",
  Stripe: "stripe",
  Supabase: "supabase",
  Cloudflare: "cloudflare",
  Webflow: "webflow",
  Mixpanel: "mixpanel",
  Dropbox: "dropbox",
  ClickUp: "clickup",
  Atlassian: "atlassian",
  Mailchimp: "mailchimp",
  Zapier: "zapier",
  WordPress: "wordpress",
};

/** Whether a brand has its own logo here, by id or by display name. */
export const hasIntegrationIcon = ({ id, name } = {}) => Boolean(MAP[id || NAME_TO_ID[name]]);

export const IntegrationIcon = ({ id, name, size = 18, className = "" }) => {
  const key = id || NAME_TO_ID[name];
  const entry = MAP[key];
  if (!entry) return null;
  const { Icon, color } = entry;
  return <Icon size={size} style={{ color }} className={className} />;
};
